import { useInfiniteQuery } from '@tanstack/react-query';
import { type AuditQuery, listAuditLog } from '../lib/audit-api.js';

/* Hook TanStack Query da trilha de auditoria (ADR-0708), espelhando `use-users.ts`:
   paginação keyset por cursor (`initialPageParam undefined` + `getNextPageParam last.nextCursor`).
   Todos os filtros são server-side (q/action/targetType/actorId/from/to) e compõem a queryKey. */
export function useAuditLog(filters: AuditQuery) {
  return useInfiniteQuery({
    queryKey: ['audit', 'list', filters],
    queryFn: ({ pageParam }) => listAuditLog({ ...filters, cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
}
